import styled from 'styled-components';

export const SettingsContainer = styled.div`
  display: flex;
  height: 100%;
  gap: 16px;
`;

interface SettingsContentProps {
  isUsersPage?: boolean;
}

export const SettingsContent = styled.div<SettingsContentProps>`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 60px 24px 24px;

  ${({ isUsersPage }) =>
    isUsersPage &&
    `
    overflow-x: hidden;
    overflow-y: scroll;
  `}

  display: flex;
  flex-direction: column;
`;
